console.log('[CartSync Globo] loaded');

(function () {
  const COUNT_SEL = '.cart-bubble__text-count[data-testid="cart-bubble"]';
  const BUBBLE_SEL = '.cart-bubble';

  async function refreshHeaderCount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const count = Number(cart?.item_count || 0);

      const countEl = document.querySelector(COUNT_SEL);
      const bubble = document.querySelector(BUBBLE_SEL);

      if (countEl) {
        countEl.textContent = String(count);
        countEl.classList.toggle('hidden', count === 0); // 👈 muestra/oculta número
      }

      if (bubble) {
        bubble.classList.toggle('visually-hidden', count === 0); // 👈 muestra/oculta burbuja completa
      }
    } catch (_) {}
  }

  // Globo hace doble add → refrescamos 2 veces
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        setTimeout(refreshHeaderCount, 350);
        setTimeout(refreshHeaderCount, 950);
      }
    } catch (_) {}
    return res;
  };

  document.addEventListener('DOMContentLoaded', refreshHeaderCount);
})();
